export const STATUSES = ["New", "Contacted", "Qualified", "Proposal", "Won", "Lost"];

const PILL = "inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-[11px] font-medium border";

// Coloured status pills — light background + matching text so the list is scannable at a glance.
export const STATUS_COLORS = {
  New:       `${PILL} bg-slate-50 text-slate-700 border-slate-200`,
  Contacted: `${PILL} bg-sky-50 text-sky-700 border-sky-200`,
  Qualified: `${PILL} bg-violet-50 text-violet-700 border-violet-200`,
  Proposal:  `${PILL} bg-amber-50 text-amber-800 border-amber-200`,
  Won:       `${PILL} bg-emerald-50 text-emerald-700 border-emerald-200`,
  Lost:      `${PILL} bg-rose-50 text-rose-700 border-rose-200`,
};

// Hex equivalents for charts (Recharts / SVG).
export const STATUS_HEX = {
  New:       "#94A3B8", // slate-400
  Contacted: "#0EA5E9", // sky-500
  Qualified: "#8B5CF6", // violet-500
  Proposal:  "#F59E0B", // amber-500
  Won:       "#10B981", // emerald-500
  Lost:      "#F43F5E", // rose-500
};

// Light pastel card backgrounds for Kanban - derived from lead.status
export const STATUS_CARD_COLORS = {
  New: "bg-slate-50 border-slate-200 hover:bg-slate-100",
  Contacted: "bg-sky-50 border-sky-200 hover:bg-sky-100",
  Qualified: "bg-violet-50 border-violet-200 hover:bg-violet-100",
  Proposal: "bg-amber-50 border-amber-200 hover:bg-amber-100",
  Won: "bg-emerald-50 border-emerald-200 hover:bg-emerald-100",
  Lost: "bg-rose-50 border-rose-200 hover:bg-rose-100",
};

// Left accent bar color for cards (a slightly stronger tone)
export const STATUS_ACCENT = {
  New: "bg-slate-400",
  Contacted: "bg-sky-500",
  Qualified: "bg-violet-500",
  Proposal: "bg-amber-500",
  Won: "bg-emerald-500",
  Lost: "bg-rose-500",
};

export const STATUS_DOTS = {
  New: "bg-slate-400",
  Contacted: "bg-sky-500",
  Qualified: "bg-violet-500",
  Proposal: "bg-amber-500",
  Won: "bg-emerald-500",
  Lost: "bg-rose-500",
};

// Priority pills — colour-coded so urgent leads stand out.
export const PRIORITY_COLORS = {
  Low:    `${PILL} bg-slate-50 text-slate-500 border-slate-200`,
  Medium: `${PILL} bg-blue-50 text-blue-700 border-blue-200`,
  High:   `${PILL} bg-amber-50 text-amber-800 border-amber-200`,
  Urgent: `${PILL} bg-rose-50 text-rose-700 border-rose-200`,
};

export const PRIORITY_DOTS = {
  Low: "bg-slate-300",
  Medium: "bg-blue-500",
  High: "bg-amber-500",
  Urgent: "bg-rose-500",
};

export const SOURCES = ["Manual", "Website", "Referral", "Social", "Ad Campaign", "Import", "Cold Call", "Event", "Other"];

// Source pills — each source gets a distinct light tint.
export const SOURCE_COLORS = {
  Manual:      `${PILL} bg-slate-50 text-slate-600 border-slate-200`,
  Website:     `${PILL} bg-sky-50 text-sky-700 border-sky-200`,
  Referral:    `${PILL} bg-emerald-50 text-emerald-700 border-emerald-200`,
  Social:      `${PILL} bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200`,
  "Ad Campaign": `${PILL} bg-orange-50 text-orange-700 border-orange-200`,
  Import:      `${PILL} bg-indigo-50 text-indigo-700 border-indigo-200`,
  "Cold Call": `${PILL} bg-cyan-50 text-cyan-700 border-cyan-200`,
  Event:       `${PILL} bg-violet-50 text-violet-700 border-violet-200`,
  Other:       `${PILL} bg-slate-50 text-slate-600 border-slate-200`,
};

// Cycle-through palette for charts / performance bars — mix of hues to break the blue monotony.
export const ACCENT_PALETTE = [
  "#1D63ED", // brand blue
  "#10B981", // emerald
  "#F59E0B", // amber
  "#8B5CF6", // violet
  "#0EA5E9", // sky
  "#F43F5E", // rose
  "#14B8A6", // teal
  "#F97316", // orange
];
